import { render, staticRenderFns } from "./AuthenticationDialog.vue?vue&type=template&id=dfb7dcba&scoped=true&"
import script from "./AuthenticationDialog.vue?vue&type=script&lang=ts&"
export * from "./AuthenticationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticationDialog.vue?vue&type=style&index=0&id=dfb7dcba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb7dcba",
  null
  
)

export default component.exports